import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable()
export class BusyServices {
	
	private busy: Subscription;
	
	getBusy() {
		return this.busy;
	}
	
	setBusy(http) {
		this.busy = http;
	}
	
	onBusyStop() {
		this.busy.unsubscribe();
	}
}
